module.exports = __webpack_public_path__ + "img/product_102.50f076b.svg";